function getLabs(company) {
  if (!("laboratories" in company)) {
    return "";
  }
  return company.laboratories
    .map((lab) => {
      if ("code" in lab && "name" in lab && "id" in lab) {
        return lab.code + "-" + lab.name;
      }
      return [];
    })
    .join();
}

export function getExcelData(companies) {
  //   companies:  [    {
  //     "id": 174326,
  //     "code": "ABC",
  //     "name": "TEST TEMPORAL",
  //     "representative": "Noel Diaz",
  //     "telephone": "123456789",
  //     "laboratories": [
  //         {
  //             "id": 174327,
  //             "code": "A1",
  //             "name": "LAB TEST TEMPORAL"
  //         }
  //     ]
  // }]
  let rows = [];

  companies.forEach((elem, index) => {
    var _known = {
      Numero: index + 1,
      Codigo: elem.code,
      Nombre: elem.name,
      Representate: elem.representative,
      Telefono: elem.telephone,
      Laboratorios: getLabs(elem),
    };
    rows.push(_known);
  });
  return rows;
}
